<template lang="html">
  <div class="loading-page" v-show="loading">
    <van-loading size="34px" color="#1989fa" vertical>{{loadTxt || '加载中...'}}</van-loading>
  </div>
</template>
<script>
export default {
  props: {
    loading:true,
    loadTxt:""
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
.loading-page {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 120vh;
  background: rgba(0, 0, 0,0.8);
  text-align: center;
  padding-top: 40vh;
  font-size: 30px;
  font-family: sans-serif;
  z-index: 99999;
}
.van-loading__text{
  color: #1989fa;
  font-size: 30px;
}
</style>